import { AlertColor } from "@mui/material";
import { useCustomAlertStore } from "@mirage/store/store";

export type ShowAlert = (message: string, severity: AlertColor, duration?: number) => void;

const useAlertService = () => {
    const showAlert = useCustomAlertStore((s) => s.showAlert);
    return showAlert;
};

export default useAlertService;
